import React from 'react';

const sizeClasses = {
  sm: 'h-8',
  md: 'h-10',
  lg: 'h-12',
  xl: 'h-14'
};

const BrandLogo = ({ size = 'md', compact = false, className = '' }) => {
  const src = '/favicon.svg?v=orange';

  const alt = compact ? 'Go Rides mark' : 'Go Rides logo';

  return (
    <img
      src={src}
      alt={alt}
      className={`${sizeClasses[size] || sizeClasses.md} w-auto ${className}`.trim()}
    />
  );
};

export default BrandLogo;
